import { render, staticRenderFns } from "./MonitorPlayer.vue?vue&type=template&id=190b6b94&scoped=true"
import script from "./MonitorPlayer.vue?vue&type=script&lang=js"
export * from "./MonitorPlayer.vue?vue&type=script&lang=js"
import style0 from "./MonitorPlayer.vue?vue&type=style&index=0&id=190b6b94&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "190b6b94",
  null
  
)

export default component.exports